/**
 * @generated SignedSource<<6ce5501e59e80d689394968868615d7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgAdminTopicsEditQuery$variables = {
  topicId: string;
};
export type OrgAdminTopicsEditQuery$data = {
  readonly organisation: {
    readonly topic: {
      readonly allPotentialReceiverStores: ReadonlyArray<{
        readonly store: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelectorMain_receiverStore" | "StoreSelector_store">;
        };
      }>;
      readonly allPotentialTeams: ReadonlyArray<{
        readonly id: string;
        readonly store: {
          readonly id: string;
        };
        readonly " $fragmentSpreads": FragmentRefs<"OrgAdminTeamsSelector_teams" | "ReceiverStoresSelectorTeamsIndicator_teams">;
      }>;
      readonly allReceiverStores: ReadonlyArray<{
        readonly routedTeams: ReadonlyArray<{
          readonly id: string;
        } | null> | null;
        readonly store: {
          readonly id: string;
        };
      }>;
      readonly description: string | null;
      readonly hasAllStores: boolean;
      readonly isDefault: boolean;
      readonly isPrivate: boolean;
      readonly name: string;
      readonly teams: ReadonlyArray<{
        readonly id: string;
      }> | null;
    } | null;
  } | null;
};
export type OrgAdminTopicsEditQuery = {
  response: OrgAdminTopicsEditQuery$data;
  variables: OrgAdminTopicsEditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topicId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "topicId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "teams",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDefault",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAllStores",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "store",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "routedTeams",
  "plural": true,
  "selections": (v5/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminTopicsEditQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "allPotentialReceiverStores",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "StoreSelector_store"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ReceiverStoresSelectorMain_receiverStore"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "allPotentialTeams",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "OrgAdminTeamsSelector_teams"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReceiverStoresSelectorTeamsIndicator_teams"
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "allReceiverStores",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrgAdminTopicsEditQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "OrgTopic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "allPotentialReceiverStores",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "includeExternalId",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "workspaceBreadcrumbs",
                        "storageKey": "workspaceBreadcrumbs(includeExternalId:true)"
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "allPotentialTeams",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreTopic",
                    "kind": "LinkedField",
                    "name": "topics",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "includeExternalId",
                            "value": false
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "workspaceBreadcrumbs",
                        "storageKey": "workspaceBreadcrumbs(includeExternalId:false)"
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "allReceiverStores",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3e1ab06f8932d0410f9b68393faef6db",
    "id": null,
    "metadata": {},
    "name": "OrgAdminTopicsEditQuery",
    "operationKind": "query",
    "text": "query OrgAdminTopicsEditQuery(\n  $topicId: ID!\n) {\n  organisation {\n    topic(id: $topicId) {\n      name\n      description\n      teams {\n        id\n      }\n      isDefault\n      isPrivate\n      hasAllStores\n      allPotentialReceiverStores {\n        store {\n          id\n          ...StoreSelector_store\n          ...ReceiverStoresSelectorMain_receiverStore\n        }\n        id\n      }\n      allPotentialTeams {\n        id\n        ...OrgAdminTeamsSelector_teams\n        ...ReceiverStoresSelectorTeamsIndicator_teams\n        store {\n          id\n        }\n      }\n      allReceiverStores {\n        store {\n          id\n        }\n        routedTeams {\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment OrgAdminTeamsSelector_teams on Team {\n  name\n  id\n  ...OrgTeamListItem_team\n}\n\nfragment OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store on Store {\n  workspaceBreadcrumbs(includeExternalId: false)\n}\n\nfragment OrgStoreWorkspaceBreadcrumbs_store on Store {\n  workspaceBreadcrumbs(includeExternalId: true)\n}\n\nfragment OrgTeamListItem_team on Team {\n  name\n  ...AHTeamIcon\n  color\n  topics {\n    id\n    name\n  }\n  store {\n    name\n    ...OrgStoreWorkspaceBreadcrumbsWithoutExternalId_store\n    id\n  }\n}\n\nfragment ReceiverStoresSelectorMain_receiverStore on Store {\n  id\n  name\n  ...OrgStoreWorkspaceBreadcrumbs_store\n}\n\nfragment ReceiverStoresSelectorTeamsIndicator_teams on Team {\n  id\n  name\n  ...AHTeamIconCircle\n}\n\nfragment StoreSelector_store on Store {\n  id\n  name\n  workspaceBreadcrumbs(includeExternalId: true)\n}\n"
  }
};
})();

(node as any).hash = "59d6d9d7516bcffe9c2ab9031790d07c";

export default node;
